import { render, staticRenderFns } from "./new-year.vue?vue&type=template&id=ed6d4658&scoped=true&"
import script from "./new-year.vue?vue&type=script&lang=js&"
export * from "./new-year.vue?vue&type=script&lang=js&"
import style0 from "./new-year.vue?vue&type=style&index=0&id=ed6d4658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6d4658",
  null
  
)

export default component.exports